<template>
    <div>
        <template v-if="videoUrl">
            <div class="text-subtitle-1 font-weight-bold mb-3 mt-6">{{ $t('mensajes.central_reservas.ayuda_contenido.video_tutorial') }}</div>
            <div class="text-caption grey--text text--darken-1 mb-3">
                {{ videoTitulo || $t('mensajes.central_reservas.ayuda_contenido.video_ayuda') }}
            </div>
            <div class="ayuda-video-wrap mb-6">
                <div class="ayuda-video-embed">
                    <iframe
                        :src="videoUrl"
                        loading="lazy"
                        :title="videoTitulo || $t('mensajes.central_reservas.ayuda_contenido.video_ayuda')"
                        allowfullscreen
                        allow="encrypted-media; fullscreen; microphone; screen-wake-lock;"
                    />
                </div>
            </div>
        </template>

        <div class="text-subtitle-1 font-weight-bold mb-3 mt-6">{{ $t('mensajes.central_reservas.ayuda_contenido.preguntas_frecuentes') }}</div>
        <v-expansion-panels v-if="preguntasFiltradas.length" accordion focusable>
            <v-expansion-panel v-for="pregunta in preguntasFiltradas" :key="pregunta.id">
                <v-expansion-panel-header>
                    <div class="d-flex align-center pr-2">
                        <v-icon small class="mr-2" :color="color">mdi-help-circle-outline</v-icon>
                        <span class="font-weight-medium">{{ pregunta.pregunta }}</span>
                    </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <div class="text-body-2 mt-4 ayuda-respuesta" v-html="pregunta.respuesta" />
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <v-alert v-else class="mt-4" dense text type="info">
            {{ $t('mensajes.central_reservas.ayuda_contenido.sin_resultados') }}
        </v-alert>
    </div>
</template>

<script>
export default {
    name: 'AyudaTemaBase',
    props: {
        busqueda: {
            type: String,
            default: ''
        },
        color: {
            type: String,
            default: '#455A64'
        },
        faqs: {
            type: Array,
            default: () => []
        },
        videoUrl: {
            type: String,
            default: ''
        },
        videoTitulo: {
            type: String,
            default: ''
        }
    },
    computed: {
        preguntasFiltradas() {
            const texto = (this.busqueda || '').toString().trim().toLowerCase();
            if (!texto) return this.faqs;

            return this.faqs.filter((pregunta) => {
                const preguntaTexto = (pregunta.pregunta || '').toLowerCase();
                const respuestaTexto = (pregunta.respuesta || '')
                    .replace(/<[^>]*>/g, ' ')
                    .toLowerCase();
                return preguntaTexto.includes(texto) || respuestaTexto.includes(texto);
            });
        }
    }
};
</script>

<style scoped>
.ayuda-video-wrap {
    display: flex;
    justify-content: center;
}

.ayuda-video-embed {
    position: relative;
    overflow: hidden;
    aspect-ratio: 1920 / 1080;
    width: 100%;
    max-width: 860px;
    border-radius: 14px;
    background: #dfe6e9;
}

.ayuda-video-embed iframe {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border: none;
    padding: 0;
    margin: 0;
    overflow: hidden;
}

.ayuda-respuesta {
    white-space: normal;
}

.ayuda-respuesta :deep(p) {
    margin-bottom: 12px;
}

.ayuda-respuesta :deep(ul),
.ayuda-respuesta :deep(ol) {
    padding-left: 20px;
    margin-bottom: 12px;
}

.ayuda-respuesta :deep(img) {
    max-width: 100%;
    border-radius: 10px;
    margin-top: 12px;
}
</style>
